import React from 'react';
import { Modal } from 'react-bootstrap';

const SpinnerPage = (props) =>
    <Modal
        //{...props} -- this doesn't worth with legacy version of Edge
        show={props.show}
        size="lg"
        animation={false}
        >
        <Modal.Body>
            <div id="circularG">
                <div id="circularG_1" className="circularG"></div>
                <div id="circularG_2" className="circularG"></div>
                <div id="circularG_3" className="circularG"></div>
                <div id="circularG_4" className="circularG"></div>
                <div id="circularG_5" className="circularG"></div>
                <div id="circularG_6" className="circularG"></div>
                <div id="circularG_7" className="circularG"></div>
                <div id="circularG_8" className="circularG"></div>
            </div>
        </Modal.Body>
    </Modal>

export default SpinnerPage;